import { createSelector } from 'reselect';

import { getEditingCaseParticipants, getCurrentCaseParticipants } from '../cases/selector';

function _getCaseMedicatTeamParticipants(participants) {
  return participants
    .map((p) => {
      if (!p.participant?.isMedicalTeam) return null;
      return {
        email: p.profile?.email,
        phone: p.profile?.phone,
        providerType: p.profile?.roleTitle,
        providerName: p.profile?.fullName,
        userId: p.participant.userId,
        medicalTeamId: p.participant.userId,
      };
    })
    .filter((i) => i !== null);
}

export const getEditingCaseMedicalTeamParticipants = createSelector(
  getEditingCaseParticipants,
  _getCaseMedicatTeamParticipants
);

export const getCurrentCaseMedicalTeamParticipants = createSelector(
  getCurrentCaseParticipants,
  _getCaseMedicatTeamParticipants
);
